import { render, staticRenderFns } from "./ButtonList.vue?vue&type=template&id=ebcb34ac&scoped=true&"
import script from "./ButtonList.vue?vue&type=script&lang=ts&"
export * from "./ButtonList.vue?vue&type=script&lang=ts&"
import style0 from "./ButtonList.vue?vue&type=style&index=0&id=ebcb34ac&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebcb34ac",
  null
  
)

export default component.exports